import { render, staticRenderFns } from "./preview-chart.vue?vue&type=template&id=50785ca0&scoped=true&"
import script from "./preview-chart.vue?vue&type=script&lang=ts&"
export * from "./preview-chart.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50785ca0",
  null
  
)

export default component.exports